import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { AppAbility, AuthService } from "../service/auth.service";
import { UserDto } from "../../api/models/user-dto";
import { UserRoleService } from "../service/user-role.service";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  constructor(
    private _router: Router,
    private _authenticationService: AuthService,
    private ability: AppAbility,
    private userRoleService: UserRoleService
  ) {}

  // canActivate
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser: UserDto = this._authenticationService.currentUserValue;

    if (currentUser) {
      //check if route is restricted by permission
      const routePermission = route.data["permission"];
      if (routePermission && !this.ability.can(routePermission.action, routePermission.subject)) {
        this._router.navigate(["/not-authorized"]);
        return false;
      }

      // check if route is restricted by role
      const routeRoles = route.data["roles"];
      if (route.data["roles"] && !this.userRoleService.rolesMatch(routeRoles, currentUser)) {
        // role not authorised so redirect to not-authorized page
        this._router.navigate(["/not-authorized"]);
        return false;
      }

      // authorised so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this._router.navigate(["/login"], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
